"use client";
import LoginView from "@/components/screens/login/LoginView";
import { USER_MODULES } from "@/service/login.service";
import React, { useEffect, useRef, useState } from "react";
// import { useRouter } from "next/router";
import { toast } from "react-toastify";
import { handleAxiosError } from "@/lib/errorHandler";

const Page = () => {
  // const router = useRouter();
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(true);
  const refreshTimerRef = useRef(null);
  if (refreshTimerRef.current) {
    clearTimeout(refreshTimerRef.current);
    refreshTimerRef.current = null;
  }
  const module_access = async () => {
    const access_token = sessionStorage.getItem("access_token");
    try {
      window.location.href = "/workspace";
    } catch (error) {
      handleAxiosError(error);
      window.location.href = "/";
    }
  };
  const startPost_Login_Cycle = () => {
    module_access();
  };

  // function to handle idle timer
  useEffect(() => {
    if (sessionStorage.getItem("isLogin") === "true" && !sessionStorage.getItem("Modules_Access")) {
      window.location.href = "/workspace";
    } else {
      sessionStorage.clear(); // Clear any stale session data on load
      setIsLoginModalOpen(true);
    }
  }, []);
  // function to handle idle timer
  useEffect(() => {
    sessionStorage.clear(); // Clear any stale session data on load
    setIsLoginModalOpen(true);
    if (sessionStorage.getItem("isLogin") !== "true") {
      return;
    }
    let inactivityTimer;
    let warningTimer;
    let reminderTimer;
    let countdown = 59;
    let toastId = null;
    let interval = null;

    // Stub function - inactivity timer is currently disabled
    const resetTimer = () => {
      // Timer functionality is disabled, so this is a no-op
    };

    const handleActivity = () => {
      resetTimer();
    };

    const handleLogout = () => {
      clearTimeout(inactivityTimer);
      clearTimeout(warningTimer);
      clearTimeout(reminderTimer);
      clearInterval(interval);

      sessionStorage.removeItem("is_logged_in");

      if (toastId) {
        toast.dismiss(toastId);
        toastId = null;
      }

      toast.info("Logged out due to inactivity", {
        position: "top-right",
      });

      setTimeout(() => {
        window.location.reload();
      }, 100);
    };

    window.addEventListener("mousemove", handleActivity);
    window.addEventListener("keydown", handleActivity);
    window.addEventListener("click", handleActivity);
    window.addEventListener("scroll", handleActivity);

    resetTimer();

    return () => {
      clearTimeout(inactivityTimer);
      clearTimeout(warningTimer);
      clearTimeout(reminderTimer);
      clearInterval(interval);
      toast.dismiss(toastId);
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("keydown", handleActivity);
      window.removeEventListener("click", handleActivity);
      window.removeEventListener("scroll", handleActivity);
    };
  }, []);

  // function to handle idle timer
  return (
    <>
      {isLoginModalOpen && (
        <LoginView
          onLoginSuccess={() => startPost_Login_Cycle()}
          onLoginFailure={() => setIsLoginModalOpen(true)}
        />
      )}
    </>
  );
};

export default Page;
